import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse, INVALID_ID } from "../common";
import { HomeworkInfo } from "./homeworkSlice";
import { getToken } from "../../features/user/UserAvatar";
import { emptyHomework } from "./homework";

export interface HomeworkInsUptState {
  state: LoadStateInfo;
  homework: HomeworkInfo;
}

const initialState: HomeworkInsUptState = {
  state: notStarted(),
  homework: emptyHomework(0, 0),
};

export interface HomeworkInsertRequest {
  homework: HomeworkInfo;
}
export const homeworkInsert = createAsyncThunk(
  "homeworkInsert",
  async (param: HomeworkInsertRequest, thunkAPI) => {
    console.debug("insert homework");
    const response = await fetch(`${getBackendUrl()}/api/homework`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.homework)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface HomeworkUpdateRequest {
  homework: HomeworkInfo;
}
export const homeworkUpdate = createAsyncThunk(
  "homeworkUpdate",
  async (param: HomeworkUpdateRequest, thunkAPI) => {
    console.debug("update homework");
    const response = await fetch(`${getBackendUrl()}/api/homework/${param.homework.id}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.homework)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface HomeworkDeleteRequest {
  homeworkId: string;
}
export const homeworkDelete = createAsyncThunk(
  "homeworkDelete",
  async (param: HomeworkDeleteRequest, thunkAPI) => {
    console.debug("delete homework");
    const response = await fetch(`${getBackendUrl()}/api/homework/${param.homeworkId}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      }
    });
    if(response.ok) {
      return { homeworkId: param.homeworkId };
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const homeworkInsUpdSlice = createSlice({
  name: "homeworkInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<HomeworkInfo>) => {
      state.state = notStarted();
      state.homework = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.homework = emptyHomework(0, 0);
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(homeworkInsert.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(homeworkInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.homework = action.payload;
      })
      .addCase(homeworkInsert.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(homeworkUpdate.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(homeworkUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.homework = action.payload;
      })
      .addCase(homeworkUpdate.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(homeworkDelete.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(homeworkDelete.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.homework = emptyHomework(0, 0);
      })
      .addCase(homeworkDelete.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

export const selectHomeworkInsUpd = (state: RootState) => state.homeworkInsUpd;

export default homeworkInsUpdSlice.reducer;
